module.exports = __webpack_public_path__ + "media/images/delete-08d0641465ec535677f9e4455f69c67f.png";